import { Pipe, PipeTransform } from '@angular/core';

import { Currency } from '@shared/services/gql.service';
import { Utils } from '@shared/utils/utils';

@Pipe({
  name: 'money',
  standalone: true,
})
export class MoneyPipe implements PipeTransform {
  transform(value?: null | number | undefined, currency?: Currency, showDecimals = true): string {
    const options = showDecimals ? {} : { maximumFractionDigits: 0, minimumFractionDigits: 0 };

    return Utils.currencyFormatter(value || 0, options, currency);
  }
}
